import request from '@/api-v2/request';
import type { CustomPropertyRequestDTO, CustomPropertyResponseDTO } from './types/custom-properties';

export const getCustomProperties = (
  params: {
    codes?: string[];
    shouldFetchAll?: boolean;
    teamId?: number;
  } = {},
  signal: AbortSignal,
): Promise<CustomPropertyResponseDTO[]> =>
  request({
    url: `/teams/custom-properties/query`,
    method: 'post',
    data: params,
    signal,
  }).then((o): CustomPropertyResponseDTO[] => o.data);

export const createCustomProperty = (data: CustomPropertyRequestDTO): Promise<CustomPropertyResponseDTO> =>
  request({
    url: `/teams/custom-properties`,
    method: 'post',
    data,
  }).then((o): CustomPropertyResponseDTO => o.data);

export const updateCustomProperty = (id: string, data: CustomPropertyResponseDTO): Promise<CustomPropertyResponseDTO> =>
  request({
    url: `/teams/custom-properties/${id}`,
    method: 'put',
    data,
  }).then((o): CustomPropertyResponseDTO => o.data);

export const deleteCustomProperty = (id: string): Promise<CustomPropertyResponseDTO> =>
  request({
    url: `/teams/custom-properties/${id}`,
    method: 'delete',
  }).then((o): CustomPropertyResponseDTO => o.data);

export const getStrategyIdsByPropertyId = (propertyId: string): Promise<CustomPropertyResponseDTO[]> =>
  request({
    url: `/teams/custom-properties/strategy-attributes/${propertyId}`,
    method: 'get',
  }).then((o): CustomPropertyResponseDTO[] => o.data);

export const getStrategyIdsByPropertyIdsAndValueIds = (
  data: { propertyId: string; valueId: string }[],
  signal: AbortSignal,
): Promise<string[]> =>
  request({
    url: `/teams/custom-properties/strategy-attributes`,
    method: 'post',
    data,
    signal,
  }).then((o): string[] => o.data);
